var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 72,
    viewBox: "0 0 80 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0622 4.03173C43.3679 -0.634933 36.6321 -0.634923 33.9378 4.03174L1.06545 60.9684C-1.62885 65.635 1.73903 71.4684 7.12763 71.4684H72.8724C78.261 71.4684 81.6289 65.635 78.9346 60.9684L46.0622 4.03173ZM39.905 47.7352C38.5173 47.7352 37.3738 46.6462 37.3061 45.2601L36.3428 25.529L36.2153 21.8003C36.1439 19.713 37.8166 17.9822 39.905 17.9822C41.9935 17.9822 43.6661 19.713 43.5947 21.8002L43.4672 25.529L42.5039 45.2601C42.4362 46.6462 41.2927 47.7352 39.905 47.7352ZM39.9566 60.0056C37.8752 60.0056 36.1879 58.3183 36.1879 56.2369V56.0646C36.1879 53.9832 37.8752 52.2959 39.9566 52.2959C42.038 52.2959 43.7253 53.9832 43.7253 56.0646V56.2369C43.7253 58.3183 42.038 60.0056 39.9566 60.0056Z",
    fill: "#F1605F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.a8b45a73f1aacb0b644814d403d9804f.svg";
export { ForwardRef as ReactComponent };